import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconError: React.FC = () => (
    <Icon viewBox="0 0 24 24" fill="none">
        <line
            x1="15.182"
            y1="8.818"
            x2="8.818"
            y2="15.181"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5px"
        />
        <line
            x1="8.818"
            y1="8.818"
            x2="15.182"
            y2="15.181"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5px"
        />
        <circle
            cx="12"
            cy="12"
            r="11.25"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5px"
        />
    </Icon>
);
